<h3 class="body-400">Additional recipients</h3>

<div class="additional-recipients-description small-300 mt-2">
  Cc or Bcc additional recipients based on the age (in days) of the oldest outstanding invoice on a statement.
</div>

<!-- Additional recipients table -->
<div class="additional-recipients-grid mt-6">
  <label class="text-start"> Recipient </label>

  <div class="d-flex flex-row">
    <label class="email-Notification-type-cell"> Cc </label>

    <label class="email-Notification-type-cell ms-2"> Bcc </label>
  </div>

  <div>
    <!-- This div left intentionally blank -->
  </div>

  <label>0–30</label>

  <label>31–60</label>

  <label>61–90</label>

  <label>91–120</label>

  <label>Over 120</label>

  <div>
    <!-- This div left intentionally blank -->
  </div>

  <div class="hr"></div>

  <!-- Client partner -->
  <ng-container *ngIf="clientPartnerForm$ | async as clientPartnerForm" [formGroup]="clientPartnerForm">
    <div class="client-partner-label d-flex flex-row align-items-center">
      Client Partner

      <anduin-icon name="info" class="ms-1" namespace="feather-icon" tooltip="The client partner is unique to each client." />
    </div>

    <mat-radio-group class="d-flex flex-row align-items-center justify-content-around ms-1" formControlName="emailNotificationType">
      <mat-radio-button [value]="EmailNotificationType.CC" />
      <mat-radio-button class="ms-2" [value]="EmailNotificationType.BCC" />
    </mat-radio-group>

    <div>
      <!-- This div left intentionally blank -->
    </div>

    <mat-checkbox formControlName="zeroToThirty" />

    <mat-checkbox formControlName="thirtyOneToSixty" />

    <mat-checkbox formControlName="sixtyOneToNinety" />

    <mat-checkbox formControlName="ninetyOneToOneTwenty" />

    <mat-checkbox formControlName="overOneTwenty" />

    <div>
      <!-- This div left intentionally blank -->
    </div>

    <div class="hr"></div>
  </ng-container>

  <!-- Additional recipients -->
  <ng-container
    *ngIf="additionalRecipientsArrayGroup$ | async as additionalRecipientsArrayGroup"
    [formGroup]="additionalRecipientsArrayGroup"
  >
    <ng-container
      *ngFor="let additionalRecipientForm of $any(additionalRecipientsArrayGroup?.controls?.additionalRecipients?.controls); let i = index"
      formArrayName="additionalRecipients"
    >
      <ng-container [formGroup]="additionalRecipientForm">
        <div>
          <input
            #emailInputs
            class="form-input"
            [ngClass]="{
              'form-input--invalid':
                (additionalRecipientsArrayGroup?.controls?.additionalRecipients?.errors?.duplicateEmails &&
                  (additionalRecipientsArrayGroup?.controls?.additionalRecipients?.touched ||
                    additionalRecipientsArrayGroup?.controls?.additionalRecipients?.dirty)) ||
                ((additionalRecipientForm.controls?.email?.errors?.required || additionalRecipientForm.controls?.email?.errors?.email) &&
                  (additionalRecipientForm.controls?.email?.touched || additionalRecipientForm.controls?.email?.dirty)),
            }"
            formControlName="email"
            placeholder="email@example.com"
          />
        </div>

        <mat-radio-group class="d-flex flex-row align-items-center justify-content-around ms-1" formControlName="emailNotificationType">
          <mat-radio-button [value]="EmailNotificationType.CC" />
          <mat-radio-button class="ms-2" [value]="EmailNotificationType.BCC" />
        </mat-radio-group>

        <div>
          <!-- This div left intentionally blank -->
        </div>

        <mat-checkbox
          [ngClass]="{
            invalid:
              additionalRecipientForm.errors?.noBucketsSelected && (additionalRecipientForm.touched || additionalRecipientForm.dirty),
          }"
          formControlName="zeroToThirty"
        />

        <mat-checkbox
          [ngClass]="{
            invalid:
              additionalRecipientForm.errors?.noBucketsSelected && (additionalRecipientForm.touched || additionalRecipientForm.dirty),
          }"
          formControlName="thirtyOneToSixty"
        />

        <mat-checkbox
          [ngClass]="{
            invalid:
              additionalRecipientForm.errors?.noBucketsSelected && (additionalRecipientForm.touched || additionalRecipientForm.dirty),
          }"
          formControlName="sixtyOneToNinety"
        />

        <mat-checkbox
          [ngClass]="{
            invalid:
              additionalRecipientForm.errors?.noBucketsSelected && (additionalRecipientForm.touched || additionalRecipientForm.dirty),
          }"
          formControlName="ninetyOneToOneTwenty"
        />

        <mat-checkbox
          [ngClass]="{
            invalid:
              additionalRecipientForm.errors?.noBucketsSelected && (additionalRecipientForm.touched || additionalRecipientForm.dirty),
          }"
          formControlName="overOneTwenty"
        />

        <div class="d-flex align-items-center justify-content-end w-100">
          <button *ngIf="!disabled" (click)="removeAdditionalRecipient(i)" andButton color="ghost">
            <anduin-icon name="trash-2" [height]="16" [width]="16" />
          </button>
        </div>

        <!-- Validation errors -->
        <ng-container *ngIf="additionalRecipientForm.controls?.email?.touched || additionalRecipientForm.controls?.email?.dirty">
          <mat-error *ngIf="additionalRecipientForm.controls?.email?.errors?.email"> Enter a valid email address. </mat-error>
          <mat-error *ngIf="additionalRecipientForm.controls?.email?.errors?.required"> Email is required. </mat-error>
        </ng-container>
        <mat-error
          *ngIf="
            additionalRecipientsArrayGroup?.controls?.additionalRecipients?.errors?.duplicateEmails &&
            (additionalRecipientsArrayGroup?.controls?.additionalRecipients?.touched ||
              additionalRecipientsArrayGroup?.controls?.additionalRecipients?.dirty)
          "
        >
          Duplicate email addresses are not allowed. Please enter a unique email address.
        </mat-error>
        <mat-error
          *ngIf="additionalRecipientForm.errors?.noBucketsSelected && (additionalRecipientForm.touched || additionalRecipientForm.dirty)"
        >
          Please select at least one age range to notify the recipient.
        </mat-error>

        <div class="hr"></div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<button
  *ngIf="!disabled"
  class="add-email-button d-flex flex-row align-items-center mt-2"
  (click)="addFormGroup()"
  andButton
  color="ghost-secondary"
  size="small"
>
  <anduin-icon name="plus-circle" class="me-1" [height]="12" [width]="12" />
  Add email
</button>
